import { Link, useLocation } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { buttonVariants } from './Button';
import { EmptyState } from './EmptyState';

/**
 * Unknown URL inside the app shell.
 *
 * The router used to `<Navigate to="/dashboard">` on any unmatched path, which
 * meant a stale bookmark, a typo, or a link to a deleted record all silently
 * landed you on the dashboard with no explanation — the app quietly answering a
 * different question than the one you asked. It renders inside the normal shell
 * so the nav is still there to leave by.
 */
export function NotFoundPage() {
  const { pathname } = useLocation();
  return (
    <div className="mx-auto max-w-2xl">
      <div className="card px-6 py-10">
        <EmptyState
          icon={<Compass />}
          title="This page doesn't exist"
          description={
            <>
              Nothing in Solid Financials lives at{' '}
              <span className="num font-semibold text-secondary">{pathname}</span>. The link may be
              out of date, or the record it pointed at may have been removed.
            </>
          }
          action={
            <Link to="/dashboard" className={buttonVariants()}>
              Go to the dashboard
            </Link>
          }
        />
      </div>
    </div>
  );
}
